import CommonPasswordReset from '../../../common/pages/public/PasswordReset'

class PasswordReset extends CommonPasswordReset {
  constructor (props) {
    super(props)
    this.passwordResetFormTitle = '日本型枠工事業協会 [事務局]'
    this.userRoleUrl = 'admin'
    this.userRole = 'admin'
  }
}

export default PasswordReset



// WEBPACK FOOTER //
// ./src/admin/pages/public/PasswordReset.js